if (!window.Eurus.loadedScript.has('cart-countdown-timer.js')) {
  window.Eurus.loadedScript.add('cart-countdown-timer.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartCountdownTimer', (messageTemplate, minutes, expireAction) => ({
        timeLeft: null,
        timestamp: null,
        interval: null,
        formattedMessage: '',
        message: messageTemplate,
        countdownTime: minutes * 60,
        action: expireAction,
        loadingClearCart: false,
        errorMessage: false,
        clearSuccess: false,
        minutesText: '',
        initCountdown(minutesText) {
          this.minutesText = minutesText;
          const savedState = this.loadState();
          if (this.timeLeft === null || savedState.timeLeft === 0) {
            this.sync(this.countdownTime);
          }
          this.handleCountdown();
          this.clearInterval();
          this.startCountdown();
        },

        sync(countdownTime) {
  const savedState = this.loadState();

  // No saved state OR setting changed -> reset to current setting
  if (!savedState || savedState.configuredTime !== countdownTime) {
    this.timeLeft = countdownTime;
  } else if (savedState.timeLeft > 0) {
    const elapsed = Math.floor((Date.now() - savedState.timestamp) / 1000);
    this.timeLeft = Math.max(0, savedState.timeLeft - elapsed);
  } else {
    this.timeLeft = countdownTime;
  }

  this.timestamp = Date.now();
  this.saveState();
},

        reset(countdownTime) {
          this.timeLeft = countdownTime;
          this.timestamp = Date.now();
          this.saveState();
        },

        clearInterval() {
          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
        },

        clearLocalStorage() {
          localStorage.removeItem('cartCountdown');
        },

        saveState() {
  localStorage.setItem('cartCountdown', JSON.stringify({
    timeLeft: this.timeLeft,
    timestamp: this.timestamp,
    configuredTime: this.countdownTime
  }));
},

        loadState() {
          const savedState = localStorage.getItem('cartCountdown');
          return savedState ? JSON.parse(savedState) : null;
        },

        startCountdown() {
          this.interval = setInterval(() => {
            if (this.timeLeft > 0) {
              this.timeLeft--;
              this.handleCountdown();
            } else {
              this.clearInterval();
              this.handleExpireAction();
            }
          }, 1000);
        },

               handleCountdown() {
          const totalSeconds = Math.max(0, Math.floor(this.timeLeft));

          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          const parts = [];
          if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
          parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`);
          parts.push(`${seconds} ${seconds === 1 ? 'second' : 'seconds'}`);

          let humanTime = '';
          if (parts.length === 3) humanTime = `${parts[0]}, ${parts[1]}, and ${parts[2]}`;
          else if (parts.length === 2) humanTime = `${parts[0]} and ${parts[1]}`;
          else humanTime = parts[0];

          const formattedTime = `<span class="font-bold">${humanTime}</span>`;
          this.formattedMessage = this.message.replace('{timer}', formattedTime);
        },


        clearCart() {
          this.loadingClearCart = true;
          this.errorMessage = false;
          fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ "sections": Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
          })
            .then((response) => response.json())
            .then((response) => {
              this.clearSuccess = true;
              Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            })
            .catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              this.loadingClearCart = false;
            });
        },

        handleExpireAction() {
          switch (this.action) {
            case 'repeat_countdown':
              this.reset(this.countdownTime);
              this.clearInterval();
              this.startCountdown();
              break;
            case 'hide_message':
              if (document.getElementById('x-cart-countdown-timer')) {
                document.getElementById('x-cart-countdown-timer').style.display = 'none';
                this.clearLocalStorage();
              }
              break;
            case 'clear_cart':
              this.clearCart();
              break;
            default:
              console.error('Unknown action:', this.action);
          }
        },
      }));
    });
  });
}
